const FilterRegions = [
  { name: 'US EAST', id: 'us-east-1' },
  { name: 'US WEST', id: 'us-west-2' },
  { name: 'EUROPE', id: 'eu-west-1' }
];

export default FilterRegions;



// WEBPACK FOOTER //
// ./src/views/StaticData/FilterRegions.tsx